import {useEffect, useState} from 'react';

import {getUser} from '../repositories/user-memory-repository';

function useUser() {
  const [user, setUser] = useState(getUser());

  useEffect(() => {
    window.userMemoryRepository && window.userMemoryRepository.subscribe((_, state) => {
      setUser(state);
    });
  }, []);

  return user;
}

export {useUser};
